function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { getComposeEntryProps } from './composePage.js';
import { getEntryProps } from '../utils/getEntryProps.js';
import { removeLeadingSlash } from '../utils/removeLeadingSlash.js';
import { navbarThemeMap } from './navbar.js';
import { mapEntryLink } from './navlink.js';
const getProjectConfigProps = (projectConfig, path) => {
  const _getEntryProps = getEntryProps(projectConfig),
    productName = _getEntryProps.productName,
    productLink = _getEntryProps.productLink,
    secondaryProductLink = _getEntryProps.secondaryProductLink,
    legalDisclaimer = _getEntryProps.legalDisclaimer,
    subNavLinks = _getEntryProps.subNavLinks,
    sharedContent = _getEntryProps.sharedContent,
    _getEntryProps$hasSea = _getEntryProps.hasSearch,
    hasSearch = _getEntryProps$hasSea === void 0 ? false : _getEntryProps$hasSea,
    _getEntryProps$sugges = _getEntryProps.suggestedSearchTerms,
    suggestedSearchTerms = _getEntryProps$sugges === void 0 ? [] : _getEntryProps$sugges,
    customNavbarCta = _getEntryProps.customNavbarCta,
    customNavbarSecondaryCta = _getEntryProps.customNavbarSecondaryCta,
    bannerText = _getEntryProps.bannerText,
    bannerLink = _getEntryProps.bannerLink,
    navbarTheme = _getEntryProps.navbarTheme,
    customLogo = _getEntryProps.customLogo,
    customLogoHref = _getEntryProps.customLogoHref;
  const _getEntryProps2 = getEntryProps(productLink),
    productLinkLabel = _getEntryProps2.label,
    url = _getEntryProps2.url,
    productLinkContent = _getEntryProps2.composePage;
  const _getComposeEntryProps = getComposeEntryProps(productLinkContent),
    productLinkSlug = _getComposeEntryProps.composeSlug;
  const _getEntryProps3 = getEntryProps(secondaryProductLink),
    secondaryProductName = _getEntryProps3.label,
    secondaryProductUrl = _getEntryProps3.url;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO Fix this
  const mappedSubNavLinks = subNavLinks?.map(link => {
    const slug = removeLeadingSlash(link.fields?.url || link.fields?.composePage?.fields?.slug || path);
    const _mapEntryLink = mapEntryLink(link),
      url = _mapEntryLink.url,
      label = _mapEntryLink.label,
      urlLabel = _mapEntryLink.urlLabel;
    return _objectSpread(_objectSpread({}, {
      url: url ? url : path,
      label,
      urlLabel
    }), {}, {
      active: removeLeadingSlash(path) === slug
    });
  });
  const searchTags = suggestedSearchTerms.map(term => ({
    label: term,
    url: term
  }));
  const searchPath = getSearchPath(projectConfig);
  const _getEntryProps4 = getEntryProps(customNavbarCta),
    customNavbarCtaLabel = _getEntryProps4.label,
    customNavbarCtaUrl = _getEntryProps4.url;
  const _getEntryProps5 = getEntryProps(customNavbarSecondaryCta),
    customNavbarSecondaryCtaLabel = _getEntryProps5.label,
    customNavbarSecondaryCtaUrl = _getEntryProps5.url;
  const subNavSecondaryLink = secondaryProductUrl && secondaryProductName ? {
    label: secondaryProductName,
    url: secondaryProductUrl
  } : undefined;
  return {
    productName: productName || productLinkLabel,
    productUrl: productLinkSlug || url,
    subNavSecondaryLink,
    subNavLinks: mappedSubNavLinks || [],
    sharedContent,
    hasSearch,
    suggestedSearchTerms,
    searchPath,
    searchTags,
    legalDisclaimer,
    primaryLogoImageUrl: customLogo?.fields?.file?.url,
    secondaryLogoHref: customLogoHref,
    primaryCtaLabel: customNavbarCtaLabel,
    primaryCtaUrl: customNavbarCtaUrl,
    secondaryCtaLabel: customNavbarSecondaryCtaLabel,
    secondaryCtaUrl: customNavbarSecondaryCtaUrl,
    banner: bannerText ? {
      message: bannerText,
      url: bannerLink ? mapEntryLink(bannerLink).url : ''
    } : undefined,
    navbarStyleOverride: navbarTheme ? navbarThemeMap[navbarTheme] : undefined
  };
};
const replaceSearchUrl = url => {
  // eslint-disable-next-line no-useless-escape -- TODO Fix this
  const regex = /^https:\/\/[^\/]+\.([^\/]+\.[^\/]+)(?:\/(.+?)\/)?.*/;
  const match = url.match(regex);
  if (match) {
    const basePath = match[2];
    return url.replace(regex, `/${basePath}/search`);
  }
  return url;
};
const getSearchPath = projectSettings => {
  const _getEntryProps6 = getEntryProps(projectSettings),
    searchLink = _getEntryProps6.searchLink;
  // const basePath = productLink?.fields?.url || ''

  const _mapEntryLink2 = mapEntryLink(searchLink),
    url = _mapEntryLink2.url;
  const newUrl = replaceSearchUrl(url);
  return newUrl;
};
export { getProjectConfigProps, getSearchPath };
//# sourceMappingURL=projectSettings.js.map
